import React from 'react'
import { shape, string } from 'prop-types'
import { getImageType, imageBreakpoints } from './Static/images'

function SaleOffSection({ images, saleOffPath = '/3d-models?sale_off=1' }) {
  return (
    <section
      id="homepage-promotion-banner"
      className="homepage-promotional-banner"
    >
      <a href={saleOffPath}>
        <div className="homepage-promotional-banner__container">
          <picture>
            {imageBreakpoints?.map(({ media, key }) => (
              <source
                key={media}
                media={media}
                srcSet={images[key]}
                type={getImageType(images[key])}
              />
            ))}
            <img
              alt="Special promotion banner"
              className="homepage-promotional-banner__background-image"
              src={images.mobile}
              loading="lazy"
              decoding="async"
            />
          </picture>
        </div>
      </a>
    </section>
  )
}

SaleOffSection.propTypes = {
  saleOffPath: string,
  images: shape({
    mobile: string.isRequired,
    tablet: string.isRequired,
    desktop: string.isRequired,
  }).isRequired,
}

export default SaleOffSection
